import { motion } from "framer-motion";
import { Download } from "lucide-react";
import { MaskedLine, Kicker, EASE } from "@/components/Reveal";

export default function DivisionHero({ kicker, lines, intro, image, imageAlt, brochure }) {
  return (
    <section className="relative overflow-hidden px-5 pb-16 pt-32 md:px-10 md:pb-24 md:pt-40">
      <div className="mx-auto grid max-w-[1500px] items-end gap-10 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <Kicker>{kicker}</Kicker>
          <h1 className="mt-4 font-display text-5xl font-light leading-[0.95] tracking-tight sm:text-6xl lg:text-7xl">
            {lines.map((line, i) => (
              <MaskedLine key={line} delay={0.1 + i * 0.12}>
                {line}
              </MaskedLine>
            ))}
          </h1>
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.8, ease: EASE }}
            className="mt-6 max-w-xl text-base leading-relaxed text-ink/70 md:text-lg"
          >
            {intro}
          </motion.p>
        </div>
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.35, duration: 1, ease: EASE }}
          className="lg:col-span-5"
        >
          <div className="overflow-hidden rounded-t-[180px]">
            <motion.img
              src={image}
              alt={imageAlt}
              initial={{ scale: 1.15 }}
              animate={{ scale: 1 }}
              transition={{ duration: 1.6, ease: EASE }}
              className="aspect-[4/5] w-full object-cover"
            />
          </div>
          {brochure && (
            <motion.a
              href={brochure.pdf}
              target="_blank"
              rel="noreferrer"
              data-testid="brochure-download-card"
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.8, duration: 0.8, ease: EASE }}
              className="group mt-5 flex items-center gap-4 rounded-sm border border-ink/15 bg-cream p-4 transition-shadow hover:ring-2 hover:ring-kwila"
            >
              <img
                src={brochure.cover}
                alt={`${brochure.label} — brochure cover`}
                className="h-20 w-auto rounded-[2px] border border-ink/10 shadow-sm"
              />
              <div>
                <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-kwila">
                  Download our brochure
                </p>
                <p className="mt-1 font-display text-xl leading-tight">{brochure.label}</p>
                <p className="mt-0.5 text-xs text-sand">PDF · full product range</p>
              </div>
              <Download size={18} className="ml-auto shrink-0 text-sand transition-colors group-hover:text-kwila" />
            </motion.a>
          )}
        </motion.div>
      </div>
    </section>
  );
}
